import foxGridReducer from 'fox-react/dist/components/FoxGrid/reducer';
import gridNames from 'common/gridNames';

const currenciesManagementReducer = foxGridReducer(
  gridNames.currenciesManagement,
);

export default currenciesManagementReducer;
